import { httpsCallable } from 'firebase/functions';
import { functions, auth } from '../firebase/config';

interface DeletionRequestResponse {
  success: boolean;
  requestId: string;
  message: string;
}

export const submitDeletionRequest = async (): Promise<DeletionRequestResponse> => {
  try {
    // Log current auth state for debugging
    const currentUser = auth.currentUser;
    console.log('Current user before deletion request:', currentUser?.uid, currentUser?.email);
    
    if (!currentUser) {
      throw new Error('No authenticated user found');
    }
    
    const submitRequest = httpsCallable<any, DeletionRequestResponse>(
      functions,
      'privacy_submitDeletionRequest'
    );
    
    const result = await submitRequest({});
    return result.data;
  } catch (error: any) {
    console.error('Failed to submit deletion request:', error);
    // Preserve the original Firebase error message if it exists
    if (error.code && error.message) {
      throw error;
    }
    throw new Error(error.message || 'Failed to submit deletion request');
  }
};